// Bearer-token storage for the SPA.
//
// The token is the opaque session token issued by better-auth's bearer()
// plugin (returned in the `set-auth-token` response header). We hold it
// in localStorage so reloads keep the user signed in, and mirror it in
// a module-level cache so synchronous reads (e.g. fetch builders) don't
// touch storage on every call.

const STORAGE_KEY = "memkernel.auth.token";

let cached: string | null = readStorage();

function readStorage(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    // Storage can throw in private mode or with quota errors.
    return null;
  }
}

export function authToken(): string | null {
  return cached;
}

export function setAuthToken(token: string): void {
  cached = token;
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, token);
  } catch {
    /* ignore */
  }
}

export function clearAuthToken(): void {
  cached = null;
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
